/* eslint-disable no-unused-vars */
export enum roleIdByName {
  oficinasNacionales = 1,
  jefeDesarrollo = 2,
  instructor = 3,
  liderNacional = 4,
}
